module.exports = __webpack_public_path__ + "static/Phil-Wilson-3f5297665ac3ce713dbb253772c7415c.jpg";